var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"farewell"},[_c('h1',[_vm._v("Farewell Bernie!")]),_vm._v(" "),_c('ul',{staticClass:"beatbox"},_vm._l((_vm.items),function(item){return _c('li',{staticClass:"beatbox__item"},[_c('soundButton',{attrs:{"item":item}})],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e6590ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FarewellBernie.vue
// module id = null
// module chunks = 